import React from 'react';
import BootstrapModal from 'react-bootstrap/Modal';
import styled from 'styled-components';

import { otherColors } from '@/styles/colors';

interface IModal {
  show: boolean;
  onHide: () => void;
  children: React.ReactNode;
  centered?: boolean;
  width?: string;
  height?: string;
}

const Modal = ({ show, onHide, children, ...props }: IModal): React.ReactElement => {
  return (
    <StyledModal
      show={show}
      onHide={onHide}
      dialogClassName="modal-content-lg"
      aria-labelledby="example-custom-modal-styling-title"
      animation={false}
      backdrop="static"
      {...props}
    >
      {children}
    </StyledModal>
  );
};

const Header = styled.div`
  padding-bottom: 19px;
  font-weight: 300;
  font-size: 24px;
  line-height: 140%;
  color: ${otherColors.lxc.darkBlue};
`;

const Body = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: #343a40;
`;

const Breakline = styled.div`
  width: 100%;
  height: 1px;
  margin: 24px 0;
  background-color: #dee2e6;
`;

const ButtonsContainer = styled.div`
  display: flex;

  & > * {
    flex: 1 1 0;

    margin-right: 8px;
    margin-left: 8px;

    :first-child {
      margin-left: 0;
    }
    :last-child {
      margin-right: 0;
    }
  }
`;

Modal.Header = Header;
Modal.Body = Body;
Modal.Breakline = Breakline;
Modal.ButtonsContainer = ButtonsContainer;

export { Modal };

const StyledModal = styled(BootstrapModal)`
  .modal-dialog {
    width: ${props => props.width};
    max-width: ${props => props.width && 'none'};
  }
  .modal-content {
    padding: 35px 24px 24px 24px;
    background: #fff;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
    border: none;
    border-radius: 8px;
    min-height: ${props => props.height || 'unset'};
  }
`;
